module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4l4Ys"))).then(() => parcelRequire('hEqeo'));